import axios, { AxiosInstance } from 'axios';
import { Config } from '@/utils/Config';

export abstract class BaseServiceDefinition {
  private get apiBaseUrl(): string {
    return Config.Settings.ApiBaseUrl;
  }

  private axiosInstance: AxiosInstance;

  constructor() {
    this.axiosInstance = axios.create({});

    this.axiosInstance.interceptors.request.use(
      async config => {
        return config;
      },
      error => {
        return Promise.reject(error);
      }
    );
  }

  get(url: string): Promise<any> {
    return this.axiosInstance.get(this.apiBaseUrl + url);
  }

  post(url: string, body?: any): Promise<any> {
    return this.axiosInstance.post(this.apiBaseUrl + url, body);
  }
}
